var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCroixCarteTresor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 87.354,
    height: 87.354,
    viewBox: "0 0 87.354 87.354",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-close-circle",
    "data-name": "Icon ionic-ios-close-circle",
    d: "M47.052,3.375A43.677,43.677,0,1,0,90.729,47.052,43.67,43.67,0,0,0,47.052,3.375ZM58.118,62.864,47.052,51.8,35.986,62.864a3.356,3.356,0,1,1-4.746-4.746L42.306,47.052,31.24,35.986a3.356,3.356,0,0,1,4.746-4.746L47.052,42.306,58.118,31.24a3.356,3.356,0,0,1,4.746,4.746L51.8,47.052,62.864,58.118a3.371,3.371,0,0,1,0,4.746A3.333,3.333,0,0,1,58.118,62.864Z",
    transform: "translate(-3.375 -3.375)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCroixCarteTresor);
export default __webpack_public_path__ + "static/media/croix_carte_tresor.8b0da0f9.svg";
export { ForwardRef as ReactComponent };